import { SESSION_API_PREFIX } from '@/core/constants/session-api-prefix';
import { Session } from '@/core/types/session';
import { SessionMeta } from '@/core/types/session-meta';
import { SessionUpdateMetaResponse } from '@/core/types/session-update-meta-response';
import { SuccessEnvelope } from '@/core/types/success-envelope';
import { AuthenticatedHttpService } from '@/core/services/authenticated-http';
import { CognitoEnvironment } from '@/core/types/cognito-environment';
import { Borrower } from '@/core/types/borrower';
import { AccountType } from '@/core/enums/account-type';
import { UtilHelper } from '@/util/helper';

export class CoreAPIService {
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	private constructor() {}

	public static getSession(): Promise<Session> {
		return AuthenticatedHttpService.get<SuccessEnvelope<Session>>(
			SESSION_API_PREFIX,
		).then((response) => UtilHelper.snakeObjectToCamel(response.data));
	}

	public static updateSessionMeta(request: SessionMeta): Promise<SessionUpdateMetaResponse> {
		return AuthenticatedHttpService.patch<SuccessEnvelope<SessionUpdateMetaResponse>, SessionMeta>(
			`${SESSION_API_PREFIX}/meta`,
			request,
		).then((response) => UtilHelper.snakeObjectToCamel(response.data));
	}

	public static getCognitoEnvironment(): Promise<CognitoEnvironment> {
		return AuthenticatedHttpService.get<SuccessEnvelope<CognitoEnvironment>>(
			'/api/cognito/environment',
		).then((response) => response.data);
	}

	public static getPrimaryBorrower({
		type,
		id,
	}: {
		type: AccountType;
		id: string;
	}): Promise<Borrower> {
		return AuthenticatedHttpService.get<SuccessEnvelope<Borrower>>(
			`/api2/v1/${type}/${id}/primary-borrower`,
		).then((response) => UtilHelper.snakeObjectToCamel(response.data));
	}
}
